import Repository from './Repository.js';

class OpenAiRepository extends Repository {
    async messagingInitiateConversation(body) {
        return await this.post('openai/messaging/initiate_conversation', body);
    }

    async messagingFollowUpConversation(body) {
        return await this.post('openai/messaging/follow_up_conversation', body);
    }
}

export default new OpenAiRepository();
